var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInboxOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#494d7d",
    stroke: "#d6d7e2",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M722,1102a3,3,0,0,1-3-3v-5c0-.009,0-.017,0-.026v-.011c0-.005,0-.01,0-.015s0-.01,0-.016v-.01l0-.018v-.007l0-.02v-.006l0-.022v0l0-.023h0a.992.992,0,0,1,.07-.229l3.47-7.809A3,3,0,0,1,725.3,1084h9.4a3,3,0,0,1,2.745,1.784l3.47,7.81a1,1,0,0,1,.07.229h0l0,.024v0l0,.023v0l0,.021v.006l0,.019v.008c0,.006,0,.011,0,.017v.01c0,.005,0,.011,0,.016s0,.017,0,.026v5a3,3,0,0,1-3,3Zm-1-3a1,1,0,0,0,1,1h16a1,1,0,0,0,1-1v-4h-4.465l-1.7,2.554A1,1,0,0,1,732,1098h-4a1,1,0,0,1-.833-.445l-1.7-2.554H721Zm5-6a1,1,0,0,1,.832.445l1.7,2.555h2.93l1.7-2.555A1,1,0,0,1,734,1093h4.462l-2.845-6.405a1,1,0,0,0-.916-.595h-9.4a1,1,0,0,0-.915.595L721.538,1093Z",
    transform: "translate(-700 -1063)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxOn);
export default __webpack_public_path__ + "static/media/inbox-on.c65ef1f4cf6c32473035f48561996066.svg";
export { ForwardRef as ReactComponent };